import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import thunk from "redux-thunk";

import authSlice from "./reducer/auth";
import cartSlice from "./reducer/cart";
import pageSlice from "./reducer/page";

const persistConfig = {
  key: "root",
  storage,
};

const reducers = combineReducers({
  auth: authSlice.reducer,
  cart: cartSlice.reducer,
  page: pageSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
  devTools: true,
});

export default store;
